import {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import productService from '@/services/product/productService';
import {selectIsChargerRegistered, selectIsHolderRegistered} from '@/state/selectors/connectedProduct';
import {selectIsHolderInitialized} from '@/state/selectors/mw';
import {showDeviceRegistrationErrorModalAction, showHolderRegistrationModalAction} from '@/state/slices/modalSlice';

import connectionSteps from './connectionSteps';

const useRegistration = ({updateConnectionState, sync}) => {
    const dispatch = useDispatch();

    const isHolderInitialized = useSelector(selectIsHolderInitialized);

    // Check registration status for both devices
    const isChargerRegistered = useSelector(selectIsChargerRegistered);
    const isHolderRegistered = useSelector(selectIsHolderRegistered);

    // Skip holder registration if no holder is present or it's already registered
    const shouldSkipHolderRegistration = !isHolderInitialized || isHolderRegistered;

    useEffect(() => {
        if (isChargerRegistered && shouldSkipHolderRegistration) {
            startSynchronization();
        }
    }, [isChargerRegistered, shouldSkipHolderRegistration]);

    const startSynchronization = () => {
        updateConnectionState({currentStep: connectionSteps.IOT_SYNCHRONIZATION});
        sync();
    };

    const showHolderRegistrationModal = () => {
        dispatch(showHolderRegistrationModalAction());
    };

    const initiateDeviceRegistrationAndSync = () => {
        //redirect in useEffect
        if (isChargerRegistered && shouldSkipHolderRegistration) return;

        // Update to registration step
        updateConnectionState({currentStep: connectionSteps.REGISTRATION});

        // If charger is registered but holder needs registration
        if (isChargerRegistered) {
            showHolderRegistrationModal();
            return;
        }

        productService.registerConsumerProduct({
            onError: (iccError) => {
                dispatch(showDeviceRegistrationErrorModalAction({...iccError}));
            },
            onSuccess: () => {
                //redirect in useEffect
            },
            onNotRegisteredHolder: () => {
                showHolderRegistrationModal();
            },
        });
    };

    return {initiateDeviceRegistrationAndSync};
};

export default useRegistration;
